import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵdefinePipe, Pipe, ɵɵelement, ɵɵdirectiveInject, ɵɵtemplate, ɵɵpipe, ɵɵproperty, ɵɵpipeBind1, ɵɵadvance, ɵɵtextInterpolate1, ɵɵnextContext, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵclassMap, ɵɵtextInterpolate, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { NgIf, AsyncPipe, NgForOf, CommonModule } from '@angular/common';
import { IonSpinner, ToastController, IonIcon, IonicModule } from '@ionic/angular';
import format from 'date-fns/format';
import intervalToDuration from 'date-fns/intervalToDuration';
import { BehaviorSubject, of, Subject, EMPTY, timer } from 'rxjs';
import { tap, concatMap, finalize, delay, filter, switchAll, catchError, retryWhen, delayWhen } from 'rxjs/operators';
import { __awaiter } from 'tslib';
import { webSocket } from 'rxjs/webSocket';

class UtilLibService {
    constructor() {
        /*
        blank
        */
    }
}
UtilLibService.ɵfac = function UtilLibService_Factory(t) { return new (t || UtilLibService)(); };
UtilLibService.ɵprov = ɵɵdefineInjectable({ token: UtilLibService, factory: UtilLibService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UtilLibService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

class UtilLibComponent {
    constructor() {
        /*
        blank
        */
    }
    ngOnInit() {
        /*
        blank
        */
    }
}
UtilLibComponent.ɵfac = function UtilLibComponent_Factory(t) { return new (t || UtilLibComponent)(); };
UtilLibComponent.ɵcmp = ɵɵdefineComponent({ type: UtilLibComponent, selectors: [["util-util"]], decls: 2, vars: 0, template: function UtilLibComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, "util-lib works!");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UtilLibComponent, [{
        type: Component,
        args: [{
                selector: 'util-util',
                template: ` <p>util-lib works!</p> `,
                styles: [],
            }]
    }], function () { return []; }, null); })();

class DateFormatPipe {
    transform(value, ...args) {
        if (args[0] === 'distance') {
            const obj = {
                start: new Date(value),
                end: new Date(),
            };
            if (!!args[1]) {
                obj.end = new Date(args[1]);
            }
            const duration = intervalToDuration(obj);
            const str = [];
            if (duration.years !== 0) {
                str.push(`${duration.years} years`);
            }
            else if (duration.months !== 0) {
                str.push(`${duration.months} months`);
            }
            else if (duration.days !== 0) {
                str.push(`${duration.days} days`);
            }
            else {
                if (duration.hours !== 0) {
                    str.push(`${duration.hours}h`);
                }
                if (duration.minutes !== 0) {
                    str.push(`${duration.minutes}m`);
                }
                if (duration.seconds !== 0) {
                    str.push(`${duration.seconds}s`);
                }
            }
            return str.join(' ');
        }
        else if (args[0] === 'countdown') {
            const obj = {
                start: new Date(value),
                end: new Date(),
            };
            if (!!args[1]) {
                obj.end = new Date(args[1]);
            }
            const duration = intervalToDuration(obj);
            const str = [];
            if (duration.years !== 0) {
                str.push(`${duration.years}y`);
            }
            if (duration.months !== 0) {
                str.push(`${duration.months}m`);
            }
            if (duration.days !== 0) {
                str.push(`${duration.days}d`);
            }
            if (duration.hours !== 0) {
                str.push(`${duration.hours}h`);
            }
            if (duration.minutes !== 0) {
                str.push(`${duration.minutes}m`);
            }
            if (duration.seconds !== 0) {
                str.push(`${duration.seconds}s`);
            }
            return str.join(' : ');
        }
        else {
            return format(new Date(value), args[0]);
        }
    }
}
DateFormatPipe.ɵfac = function DateFormatPipe_Factory(t) { return new (t || DateFormatPipe)(); };
DateFormatPipe.ɵpipe = ɵɵdefinePipe({ name: "dateFormat", type: DateFormatPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DateFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'dateFormat',
            }]
    }], null, null); })();

class LoadingService {
    constructor() {
        this.loadingSubject = new BehaviorSubject(false);
        this.loading$ = this.loadingSubject.asObservable();
        // console.log("Loading service created ...");
    }
    showLoaderUntilCompleted(obs$) {
        return of(null).pipe(tap(() => this.loadingOn()), concatMap(() => obs$), finalize(() => this.loadingOff()));
    }
    loadingOn() {
        this.loadingSubject.next(true);
    }
    loadingOff() {
        this.loadingSubject.next(false);
    }
}
LoadingService.ɵfac = function LoadingService_Factory(t) { return new (t || LoadingService)(); };
LoadingService.ɵprov = ɵɵdefineInjectable({ token: LoadingService, factory: LoadingService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoadingService, [{
        type: Injectable
    }], function () { return []; }, null); })();

function LoadingComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelement(1, "ion-spinner", 2);
    ɵɵelementEnd();
} }
class LoadingComponent {
    constructor(loadingService) {
        this.loadingService = loadingService;
    }
    ngOnInit() {
        /* blank */
    }
}
LoadingComponent.ɵfac = function LoadingComponent_Factory(t) { return new (t || LoadingComponent)(ɵɵdirectiveInject(LoadingService)); };
LoadingComponent.ɵcmp = ɵɵdefineComponent({ type: LoadingComponent, selectors: [["util-loading"]], decls: 2, vars: 3, consts: [["class", "spinner-container", 4, "ngIf"], [1, "spinner-container"], ["name", "dots"]], template: function LoadingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, LoadingComponent_div_0_Template, 2, 0, "div", 0);
        ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵɵproperty("ngIf", ɵɵpipeBind1(1, 1, ctx.loadingService.loading$));
    } }, directives: [NgIf, IonSpinner], pipes: [AsyncPipe], styles: [".spinner-container[_ngcontent-%COMP%]{align-items:center;background:var(--ion-background-color,rgba(173,200,236,.2));bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0;z-index:20000}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoadingComponent, [{
        type: Component,
        args: [{
                selector: 'util-loading',
                templateUrl: './loading.component.html',
                styleUrls: ['./loading.component.scss'],
            }]
    }], function () { return [{ type: LoadingService }]; }, null); })();

class MessagesService {
    constructor() {
        this.subject = new BehaviorSubject([]);
        this.successSubject = new BehaviorSubject([]);
        this.successSubject$ = this.successSubject.asObservable();
        this.errors$ = this.subject.asObservable();
    }
    showErrors(...errors) {
        of(null)
            .pipe(tap(() => {
            this.subject.next(errors);
        }), delay(3000), tap(() => {
            this.subject.next([]);
        }))
            .subscribe(() => {
            /** empty */
        });
    }
    showSuccessMessages(...msg) {
        this.subject.next(msg);
    }
    showMessages(...msg) {
        this.subject.next(msg);
    }
    clearMessage() {
        this.subject.next([]);
    }
    showMsg(...msg) {
        of(null)
            .pipe(tap(() => {
            this.successSubject.next(msg);
        }), delay(3000), tap(() => {
            this.successSubject.next([]);
        }))
            .subscribe(() => {
            /** empty */
        });
    }
}
MessagesService.ɵfac = function MessagesService_Factory(t) { return new (t || MessagesService)(); };
MessagesService.ɵprov = ɵɵdefineInjectable({ token: MessagesService, factory: MessagesService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MessagesService, [{
        type: Injectable
    }], null, null); })();

function MessagesComponent_ng_container_0_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 4);
    ɵɵelement(1, "ion-icon", 5);
    ɵɵelementStart(2, "div");
    ɵɵelementStart(3, "div", 6);
    ɵɵtext(4, "Awesome!");
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 7);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelement(7, "ion-icon", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const error_r5 = ctx.$implicit;
    ɵɵadvance(6);
    ɵɵtextInterpolate1(" ", error_r5, " ");
} }
function MessagesComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵtemplate(1, MessagesComponent_ng_container_0_div_1_div_1_Template, 8, 1, "div", 3);
    ɵɵelementEnd();
} if (rf & 2) {
    const errors_r2 = ɵɵnextContext().ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", errors_r2);
} }
function MessagesComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, MessagesComponent_ng_container_0_div_1_Template, 2, 1, "div", 1);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.showMessages);
} }
function MessagesComponent_ng_container_2_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "div", 10);
    ɵɵelement(2, "ion-icon", 11);
    ɵɵelementStart(3, "div");
    ɵɵelementStart(4, "div", 6);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 7);
    ɵɵtext(7);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelement(8, "ion-icon", 8);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const success_r10 = ctx.$implicit;
    ɵɵclassMap(success_r10.type);
    ɵɵadvance(2);
    ɵɵproperty("name", success_r10.icon);
    ɵɵadvance(3);
    ɵɵtextInterpolate(success_r10.title1);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", success_r10.title2, " ");
} }
function MessagesComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, MessagesComponent_ng_container_2_ng_container_1_div_1_Template, 9, 5, "div", 9);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const successes_r7 = ɵɵnextContext().ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", successes_r7);
} }
function MessagesComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, MessagesComponent_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 0);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const successes_r7 = ctx.ngIf;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (successes_r7 == null ? null : successes_r7.length) > 0);
} }
class MessagesComponent {
    constructor(messagesService, toastController) {
        this.messagesService = messagesService;
        this.toastController = toastController;
        // console.log('Created messages component');
    }
    presentToast(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < msg.length; i++) {
                const toast = yield this.toastController.create({
                    message: msg[i],
                    duration: 2000,
                    position: 'top',
                });
                toast.present();
            }
        });
    }
    ngOnInit() {
        this.errors$ = this.messagesService.errors$.pipe(filter(x => x.length > 0), tap(x => {
            this.presentToast(x);
        }), delay(2000), tap(x => {
            this.messagesService.clearMessage();
        }));
    }
}
MessagesComponent.ɵfac = function MessagesComponent_Factory(t) { return new (t || MessagesComponent)(ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(ToastController)); };
MessagesComponent.ɵcmp = ɵɵdefineComponent({ type: MessagesComponent, selectors: [["util-messages"]], decls: 4, vars: 6, consts: [[4, "ngIf"], ["class", "messages-container", 4, "ngIf"], [1, "messages-container"], ["class", "message flex", 4, "ngFor", "ngForOf"], [1, "message", "flex"], ["name", "checkmark-circle-outline", 1, "icon"], [1, "message-title"], [1, "message-description"], ["name", "close-outline"], ["class", "messages-container", 3, "class", 4, "ngFor", "ngForOf"], [1, "flex"], [1, "icon", 3, "name"]], template: function MessagesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, MessagesComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵɵpipe(1, "async");
        ɵɵtemplate(2, MessagesComponent_ng_container_2_Template, 2, 1, "ng-container", 0);
        ɵɵpipe(3, "async");
    } if (rf & 2) {
        ɵɵproperty("ngIf", ɵɵpipeBind1(1, 2, ctx.errors$));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ɵɵpipeBind1(3, 4, ctx.messagesService.successSubject$));
    } }, directives: [NgIf, NgForOf, IonIcon], pipes: [AsyncPipe], styles: [".messages-container[_ngcontent-%COMP%]{background-color:var(--ion-color-surveyFeedback);border-radius:8px;bottom:30px;color:var(--ion-color-white-600);font-family:var(--ion-font-family-text);padding:16px;position:fixed;right:30px;z-index:3}.messages-container.error[_ngcontent-%COMP%]{background-color:#bc371b;color:#fff}.icon[_ngcontent-%COMP%]{font-size:19px;padding-right:8px}.close[_ngcontent-%COMP%]{cursor:pointer;position:absolute;right:10px;top:10px}.message-title[_ngcontent-%COMP%]{font-size:16px;font-weight:700;line-height:140%}.message-description[_ngcontent-%COMP%]{font-size:16px;font-weight:400;line-height:150%}.flex[_ngcontent-%COMP%]{display:flex}@media (min-width:768px){.messages-container[_ngcontent-%COMP%]{max-width:380px}.message-title[_ngcontent-%COMP%]{padding-bottom:7px}}@media (max-width:767.98px){.messages-container[_ngcontent-%COMP%]{max-width:320px}.message-title[_ngcontent-%COMP%]{padding-bottom:4px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MessagesComponent, [{
        type: Component,
        args: [{
                selector: 'util-messages',
                templateUrl: './messages.component.html',
                styleUrls: ['./messages.component.css'],
            }]
    }], function () { return [{ type: MessagesService }, { type: ToastController }]; }, null); })();

class WebsocketService {
    constructor() {
        this.WS_ENDPOINT = 'wss://analytics.terra.do/ws';
        this.messagesSubject$ = new Subject();
        this.messages$ = this.messagesSubject$.pipe(switchAll(), catchError(e => {
            throw e;
        }));
        /* empty */
    }
    connect(cfg = { reconnect: false }) {
        if (!this.socket$ || this.socket$.closed) {
            this.socket$ = this.getNewWebSocket();
            const messages = this.socket$.pipe(cfg.reconnect ? this.reconnect : o => o, tap({
                error: error => {
                    // console.log(error)
                },
            }), catchError(_ => EMPTY));
            this.socket$.subscribe(msg => () => {
                /* empty */
            }, // Called whenever there is a message from the server.
            // Called whenever there is a message from the server.
            err => {
                // console.log(err)
            }, // Called if at any point WebSocket API signals some kind of error.
            () => {
                // console.log('complete')
            });
            this.messagesSubject$.next(messages);
        }
    }
    reconnect(observable) {
        return observable.pipe(retryWhen(errors => errors.pipe(tap(val => {
            // console.log('[Data Service] Try to reconnect', val)
        }), delayWhen(_ => timer(3000)))));
    }
    getNewWebSocket() {
        // console.log('cnct');
        return webSocket({
            url: this.WS_ENDPOINT,
            closeObserver: {
                next: () => {
                    // console.log('[DataService]: connection closed');
                    this.socket$ = undefined;
                    this.connect({ reconnect: true });
                },
            },
        });
    }
    sendMessage(msg) {
        if (msg.event && msg.event !== -1) {
            this.socket$.next(msg);
        }
        window['rudderanalytics'].track(msg.type, msg, () => {
            // console.log(msg);
        });
    }
    close() {
        this.socket$.complete();
    }
}
WebsocketService.ɵfac = function WebsocketService_Factory(t) { return new (t || WebsocketService)(); };
WebsocketService.ɵprov = ɵɵdefineInjectable({ token: WebsocketService, factory: WebsocketService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(WebsocketService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

class UtilLibModule {
    static forRoot() {
        return {
            ngModule: UtilLibModule,
            providers: [MessagesService, LoadingService, WebsocketService],
        };
    }
}
UtilLibModule.ɵmod = ɵɵdefineNgModule({ type: UtilLibModule });
UtilLibModule.ɵinj = ɵɵdefineInjector({ factory: function UtilLibModule_Factory(t) { return new (t || UtilLibModule)(); }, imports: [[IonicModule, CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(UtilLibModule, { declarations: [UtilLibComponent,
        MessagesComponent,
        LoadingComponent,
        DateFormatPipe], imports: [IonicModule, CommonModule], exports: [UtilLibComponent,
        MessagesComponent,
        LoadingComponent,
        DateFormatPipe] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(UtilLibModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    UtilLibComponent,
                    MessagesComponent,
                    LoadingComponent,
                    DateFormatPipe,
                ],
                imports: [IonicModule, CommonModule],
                exports: [
                    UtilLibComponent,
                    MessagesComponent,
                    LoadingComponent,
                    DateFormatPipe,
                ],
            }]
    }], null, null); })();

/*
 * Public API Surface of util-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DateFormatPipe, LoadingComponent, LoadingService, MessagesComponent, MessagesService, UtilLibComponent, UtilLibModule, UtilLibService, WebsocketService };
//# sourceMappingURL=util-lib.js.map
